import * as actions from './actions'
import * as getters from './getters'
import { getFirstBrowserLanguage } from './utils'

import {
  SET_LANGUAGE
} from './mutation-types'

const defaultLanguage = function () {
  return getFirstBrowserLanguage() === 'ja' ? 'ja' : 'en'
}

// This module state will be persisted by vuex-persistedstate
const initialState = {
  lang: defaultLanguage()
}

const mutations = {
  [SET_LANGUAGE] (state, lang) {
    state.lang = lang
  }
}

export default {
  state: initialState,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/language/index.js